import { operationTypes } from './constants';
export function fetchOperationType(operationId) {
    if (operationId === void 0) { operationId = null; }
    switch (operationId) {
        case 11:
            return operationTypes.STAKE;
        case 21:
        case 22:
            return operationTypes.STAKE_PAYMENT;
        case 1901:
            return operationTypes.RINGOGAMES_STAKE;
        case 2001:
            return operationTypes.RINGOGAMES_STAKE_PAYMENT;
        case 62:
        case 92:
            return operationTypes.BONUS;
        case 31:
        case 81:
        case 3201:
            return operationTypes.ACCOUNT_CORRECTION;
        case 61:
        case 91:
        case 1301:
        case 1702:
        case 2101:
        case 2801:
        case 2901:
        case 3601:
        case 3701:
            return operationTypes.DEPOSIT;
        case 71:
        case 101:
        case 1803:
        case 3501:
            return operationTypes.WITHDRAWAL;
        case 3801:
            return operationTypes.COMBOBET_STAKE;
        case 3901:
            return operationTypes.COMBOBET_STAKE_WON;
        case 1102:
            return operationTypes.BETGAMES_STAKE;
        case 1202:
            return operationTypes.BETGAMES_STAKE_PAYMENT;
        case 4002:
            return operationTypes.HOLLYWOOD_TV_STAKE;
        case 4102:
            return operationTypes.HOLLYWOOD_TV_STAKE_PAYMENT;
        case 4202:
            return operationTypes.VIVO_STAKE;
        case 4302:
            return operationTypes.VIVO_STAKE_PAYMENT;
        case 2201:
            return operationTypes.VIRTUAL_SPORTS;
        case 2301:
            return operationTypes.VIRTUAL_SPORTS_PAYMENT;
        case 4602:
            return operationTypes.BETSOLUTIONS_STAKE;
        case 4702:
            return operationTypes.BETSOLUTIONS_STAKE_PAYMENT;
        case 4802:
            return operationTypes.TVBET_STAKE;
        case 4902:
            return operationTypes.TVBET_STAKE_PAYMENT;
        case 5202:
            return operationTypes.DATABET_STAKE;
        case 5302:
            return operationTypes.DATABET_STAKE_PAYMENT;
        case 5602:
            return operationTypes.XPRESS_STAKE;
        case 5702:
            return operationTypes.XPRESS_STAKE_PAYMENT;
        default:
            return null;
    }
}
export function fetchOperationTypeName(operationType) {
    if (operationType === void 0) { operationType = null; }
    switch (operationType) {
        case operationTypes.STAKE:
            return 'Ставка';
        case operationTypes.STAKE_PAYMENT:
            return 'Результат';
        case operationTypes.RINGOGAMES_STAKE:
            return 'Ставка RingoGames';
        case operationTypes.RINGOGAMES_STAKE_PAYMENT:
            return 'Выигрыш RingoGames';
        case operationTypes.BONUS:
            return 'Начисление бонуса';
        case operationTypes.ACCOUNT_CORRECTION:
            return 'Коррекция счета';
        case operationTypes.DEPOSIT:
            return 'Пополнение счета';
        case operationTypes.WITHDRAWAL:
            return 'Снятие средств';
        default:
            return null;
    }
}



// WEBPACK FOOTER //
// ./src/constants/operations.js